<template>
<div>
  <!-- 上 -->
    <div>
      <!-- 标签 -->
      <div class="bb2">
        <div class="tag1">招聘报名流程</div>
      </div>
      
      <!-- 内容 -->
      <div class="df mains">
        <!-- 报考流程 -->
        <div class="df bklc">
          <div class="numbers">1</div>
          <div class="colorRed">报考流程</div>
          <div class="lc">
            <ul class="df">
              <li>登陆新华社人才招聘网</li>
              <li>注册</li>
              <li>选择报考职位</li>
              <li>填报简历</li>
              <li>笔试通知（通过初选后）</li>
              <li>打印报名表、准考证</li>
              <li>参加笔试</li>
            </ul>
          </div>
        </div>
        <!-- 审核流程 -->
        <div class="df shlc">
           <div class="numbers" style="backgroundColor:#E98737">1</div>
          <div class="colorRed">审核流程</div>
          <div class="lc">
            <ul class="df" style="backgroundColor:#E98737">
              <li>初选</li>
              <li>笔试（含心里测试）</li>
              <li>面试</li>
              <li>实习</li>
              <li>体检</li>
              <li>政审</li>
              <li>签约</li>
            </ul>
          </div>
        </div>
      </div>

    </div>


  <!-- 下 -->
   <div style="margin-top:40px">
    <!-- 标签 -->
    <div class="bb2">
      <div class="tag2">常见的问题与解答</div>
    </div>

    <!-- 内容 -->
    <div class="nr" id="nr">
    
       <a-collapse accordion>
        <a-collapse-panel key="1" :header="item.QUESTION" v-for="(item,index) in questionList" :key="index">
          <p>{{item.ANSWER}}</p>
        </a-collapse-panel>
      </a-collapse>
      
    </div>
   </div>
</div>

  
</template>


<script>
export default {
  data(){
    return{
      //问题解答列表
      questionList:[]
    }
  },

  created(){
    this.getQuestionList()
  },
  
  methods:{
    //获取问题列表
    getQuestionList(){
      this.post({
        url: 'getHomeQuestion'
      }, (res) => {
        console.log(res)
        this.questionList=res
      })
    }
  }
}
</script>

<style scoped>
.df{
  display: flex;
}
li{
  list-style: none;
}
.colorRed{
 width: 73px;
  height: 18px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #CC0000;
}
.tag1{
  width: 140px;
  height: 40px;
  background-color: #CC0000;
  border-radius: 4px 4px 0 0;
  font-size: 20px;
  font-weight: blod;
  color: #fff;
  text-align: center;
  line-height: 40px;
  font-weight: bold;
}
.tag2{
  width: 170px;
  height: 40px;
  background-color: #CC0000;
  border-radius: 4px 4px 0 0;
  font-size: 20px;
  font-weight: blod;
  color: #fff;
  text-align: center;
  font-weight: bold;
  line-height: 40px;
}
.bb2{
  border-bottom: #990000 2px solid;
}
.mains{
  width: 100%;
  height: 210px;
  background-color: #fff;
  flex-direction:column;
  justify-content: center;
  align-items: center;
}
.bklc{
  margin-bottom: 20px;
  margin-top: 20px;
}

.numbers{
  width: 34px;
  height: 34px;
  background-color: #CC0000;
  border-radius: 17px;
  text-align: center;
  line-height: 34px;
  margin-right: 12px;
  color: #fff;
}
.lc{
  margin-left: 14px;
}
.lc ul{
  width: 800px;
  height: 50px;
  background: #CC0000;
  justify-content: space-between;
}

.lc ul li{
margin:0 10px;
height: 50px;
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: bold;
color: #FFFFFF;
line-height: 50px;
display: flex;
text-align: center;
}
.nr ul li{
  margin-top: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px
  }

  .nr ul li:hover{
    cursor: pointer;
  }
div /deep/ .ant-collapse-header{
  word-break:break-all;
}
div /deep/ .ant-collapse-content-box{
  word-break:break-all;
}
</style>



// WEBPACK FOOTER //
// src/views/wtjd/pages/index.vue